module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-08-d9d78a09f3afd58af75b91a52b946935.svg";